import { FormEvent, useCallback, useState } from 'react'

import { Button, Center, Group, Input, Stack, Text, TextInput, Title } from '@mantine/core'
import { useNotify, useTranslate } from 'react-admin'

import { Link } from '@mui/material'
import { IconArrowBackUp, IconCircleCheckFilled } from '@tabler/icons-react'
import { useLocation } from 'react-router-dom'
import { usePostApiUsersResetPassword } from '../../codegen/generated/users'
import { LoginLayout } from './LoginLayout'
import { NewPassword } from './NewPassword'

export const ResetPassword = () => {
  const notify = useNotify()
  const t = useTranslate()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const [email, setEmail] = useState('')

  const resetPasswordMutation = usePostApiUsersResetPassword()

  const onResetPassword = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault()

      try {
        await resetPasswordMutation.mutateAsync({
          data: {
            email,
          },
        })
      } catch (error: any) {
        notify(`Error - ${JSON.stringify(error.message)}`)
        console.error(error)
      }
    },
    [t, resetPasswordMutation.mutateAsync, email, notify],
  )

  if (searchParams.has('email') && searchParams.has('token')) {
    return (
      <LoginLayout title={t('pages.login.newPassword.title')}>
        <NewPassword
          email={searchParams.get('email') ?? ''}
          token={searchParams.get('token') ?? ''}
        />
      </LoginLayout>
    )
  }

  return (
    <LoginLayout title={t('pages.login.forgotPassword')}>
      <form onSubmit={onResetPassword}>
        <Center>
          <Title size="h4" maw="50%" ta="center">
            {t('pages.login.resetPassword.title')}
          </Title>
        </Center>
        <Stack w={300} p="md" pt="xs" pb="md" gap="xs">
          {resetPasswordMutation.isSuccess ? (
            <Group justify="center" align="center" mt="md">
              <IconCircleCheckFilled color="var(--mantine-color-green-6)" size={28} />
              <Text ta="center" c="green">
                {t('pages.login.resetPassword.description')}
              </Text>
            </Group>
          ) : (
            <>
              <Input.Wrapper label={t('_generics.email')} id="email">
                <TextInput
                  id="email"
                  name="email"
                  type="email"
                  size="md"
                  value={email}
                  onChange={e => setEmail(e.currentTarget.value)}
                />
              </Input.Wrapper>
              <Button
                type="submit"
                mt="md"
                size="md"
                loading={resetPasswordMutation.isLoading}
                disabled={email.length === 0}
              >
                {t('_generics.confirm')}
              </Button>
            </>
          )}
        </Stack>
        <Link href="/login" fontSize={12}>
          <Group align="center" justify="center" wrap="nowrap" gap="xs" mt="xs">
            <IconArrowBackUp size={18} />
            <Text size="sm">{t('pages.login.backToLogin')}</Text>
          </Group>
        </Link>
      </form>
    </LoginLayout>
  )
}
